import React from "react";
import { FormField } from "lib/hooks/useForm";

interface FieldWrapperProps {
  field: FormField;
  className?: string;
  children: React.ReactNode;
}

const FieldWrapper = ({ field, className, children }: FieldWrapperProps) => {
  return (
    <div id={`flo-field-${field}`} className={className}>
      {children}
    </div>
  );
};

export default FieldWrapper;
